import React from 'react';
import './Realisations.css';

function Realisations() {
  return (
    <section className="realisations section" id="realisations">
      <div className="realisations-container">
        <h2 className="realisations-title">Nos <span className="realisations-highlight">réalisations IA</span></h2>
        <p className="realisations-intro">
          Découvrez comment l'intelligence artificielle transforme nos projets en véritables réussites digitales. 
          Chaque projet que nous réalisons chez Viviworks.AI est le reflet d'une collaboration entre l'humain et 
          l'intelligence artificielle. Grâce à nos outils d'IA, nous analysons, optimisons et créons avec une 
          précision impossible à atteindre autrement. Nos réalisations démontrent comment la technologie peut 
          amplifier la créativité, la performance et l'impact digital.
        </p>

        <div className="realisations-grid">
          <div className="realisation-card">
            <h3 className="realisation-card-title">ETUDES DE CAS</h3>
            <p className="realisation-card-text">
              Depuis nos débuts, nous mettons l'intelligence artificielle au cœur de chaque projet digital. 
              Grâce à l'IA, nous suivons des entreprises de toutes tailles à automatiser leurs processus, 
              affiner leurs stratégies et amplifier leur visibilité en ligne. Nos études de cas prouvent que l'IA, 
              bien utilisée, n'est pas un outil : c'est un levier de croissance et d'excellence digitale.
            </p>
          </div>

          <div className="realisation-card">
            <h3 className="realisation-card-title">PORTFOLIO PROJETS</h3>
            <p className="realisation-card-text">
              Le portfolio de Viviworks.AI met en lumière la diversité et l'efficacité de nos projets conçus avec 
              l'appui de l'intelligence artificielle. Grâce à l'IA, nous adaptons chaque création aux besoins 
              uniques de nos clients, en combinant données, design et stratégie digitale pour atteindre des 
              résultats insondables. Découvrez comment l'intelligence artificielle amplifie notre créativité et 
              propulse nos clients vers le succès en ligne.
            </p>
          </div>
        </div>

        <div className="realisations-button-wrapper">
          <button className="realisations-button">Découvrir nos projets</button>
        </div>
      </div>

      <div className="realisations-bg"></div>
    </section>
  );
}

export default Realisations;

